import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table',
      params,
    });
  },
});
